import { css } from '@emotion/react';

export const getBaseHeadingGroupCss = () => {
  return css`
    display: flex;
    flex-direction: column;
    gap: 4px 0;
  `;
};
